module.exports = __webpack_public_path__ + "img/5.e82ee807.jpg";